var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlmr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_8071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "white",
    fillOpacity: 0.06
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_8071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8511 5.71186C23.5745 6.95763 25.4468 9.98305 25.2766 13.0085C20.3404 13.0085 15.4043 13.0085 10.6383 13.0085C10.6383 11.0508 11.3191 8.91525 12.6809 7.49153C14.5532 5 18.1277 4.28814 20.8511 5.71186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5106 25.1102C20.8511 25.1102 21.0213 25.2881 21.0213 25.4661C21.0213 25.6441 20.8511 25.822 20.5106 25.822H12.6809C12.3404 25.822 12.1702 25.6441 12.1702 25.4661C12.1702 25.2881 12.3404 25.1102 12.6809 25.1102H20.5106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9787 26C11.3191 26 11.4894 25.822 11.4894 25.4661C11.4894 25.1102 11.3191 24.9322 10.9787 24.9322C10.6383 24.9322 10.4681 25.1102 10.4681 25.4661C10.4681 25.822 10.6383 26 10.9787 26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7447 23.8644C16.0851 23.8644 16.2553 23.6864 16.2553 23.3305C16.2553 22.9746 16.0851 22.7966 15.7447 22.7966C15.4043 22.7966 15.234 22.9746 15.234 23.3305C15.234 23.6864 15.4043 23.8644 15.7447 23.8644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9362 22.7966C25.2766 22.7966 25.4468 22.9746 25.4468 23.3305C25.4468 23.6864 25.2766 23.8644 24.9362 23.8644H17.2766C16.9362 23.8644 16.766 23.6864 16.766 23.3305C16.766 22.9746 16.9362 22.7966 17.2766 22.7966H24.9362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.53191 21.7288C5.87234 21.7288 6.04255 21.5508 6.04255 21.1949C6.04255 20.839 5.87234 20.661 5.53191 20.661C5.19149 20.661 5.02128 20.839 5.02128 21.1949C5.02128 21.5508 5.3617 21.7288 5.53191 21.7288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1915 20.661C13.5319 20.661 13.7021 20.839 13.7021 21.1949C13.7021 21.5508 13.5319 21.7288 13.1915 21.7288H6.89362C6.55319 21.7288 6.38298 21.5508 6.38298 21.1949C6.38298 20.839 6.55319 20.661 6.89362 20.661H13.1915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4894 20.661C27.8298 20.661 28 20.839 28 21.1949C28 21.5508 27.8298 21.7288 27.4894 21.7288H14.8936C14.5532 21.7288 14.383 21.5508 14.383 21.1949C14.383 20.839 14.5532 20.661 14.8936 20.661H27.4894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1064 18.5254C25.4468 18.5254 25.617 18.7034 25.617 19.0593C25.617 19.4153 25.4468 19.5932 25.1064 19.5932H9.61702C9.44681 19.7712 9.10638 19.4153 9.10638 19.0593C9.10638 18.7034 9.2766 18.5254 9.61702 18.5254H25.1064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91489 19.7712C8.25532 19.7712 8.42553 19.5932 8.42553 19.2373C8.42553 18.8814 8.25532 18.5254 7.91489 18.5254C7.57447 18.5254 7.40425 18.8814 7.40425 19.0593C7.40425 19.2373 7.57447 19.7712 7.91489 19.7712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8723 16.5678C22.2128 16.5678 22.383 16.7458 22.383 17.1017C22.383 17.4576 22.2128 17.6356 21.8723 17.6356H6.38298C6.21277 17.6356 5.87234 17.4576 5.87234 17.1017C5.87234 16.7458 6.04255 16.5678 6.38298 16.5678H21.8723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51064 17.6356C4.85106 17.6356 5.02128 17.4576 5.02128 17.1017C5.02128 16.7458 4.85106 16.5678 4.51064 16.5678C4.17021 16.5678 4 16.7458 4 17.1017C4 17.4576 4.17021 17.6356 4.51064 17.6356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91489 15.5C8.25532 15.5 8.42553 15.322 8.42553 14.9661C8.42553 14.6102 8.25532 14.4322 7.91489 14.4322C7.57447 14.4322 7.40425 14.7881 7.40425 14.9661C7.40425 15.322 7.57447 15.5 7.91489 15.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6383 14.4322C26.9787 14.4322 27.1489 14.6102 27.1489 14.9661C27.1489 15.322 26.9787 15.5 26.6383 15.5H9.78723C9.44681 15.5 9.2766 15.322 9.2766 14.9661C9.2766 14.6102 9.44681 14.4322 9.78723 14.4322H26.6383Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_8071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_8071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21,
    fill: "white",
    transform: "translate(4 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlmr);
export default __webpack_public_path__ + "static/media/GLMR.39c5071446b7b2509e55c864bf329eef.svg";
export { ForwardRef as ReactComponent };